import React from 'react';
import { AudioType, FileToUpload, LibraryType, ManageListCallbacks } from '../types';
import { UploadFilesAudioItem } from './UploadFilesItem/UploadFilesAudioItem/UploadFilesAudioItem';
import { UploadFilesBackgroundItem } from './UploadFilesItem/UploadFilesBackgroundItem/UploadFilesBackgroundItem';
import { UploadFilesCharacterItem } from './UploadFilesItem/UploadFilesCharacterItem/UploadFilesCharacterItem';
import classNames from './UploadFilesModalList.module.scss';

interface UploadFilesListProps {
    libraryType: LibraryType;
    filesToUpload: FileToUpload[];
    manageListCallbacks: ManageListCallbacks;
    isLoading?: boolean;
    isUploadFinished?: boolean;
    onAudioTypeChange?: (aliasName: string, audioType: AudioType) => void;
}

export function UploadFilesList(props: UploadFilesListProps) {
  const {
    filesToUpload, manageListCallbacks, isLoading, isUploadFinished, libraryType, onAudioTypeChange,
  } = props;

  return (
    <ul className={classNames.filesList}>
      {libraryType === LibraryType.Background && filesToUpload.map((fileToUpload) => (
        <UploadFilesBackgroundItem
          key={fileToUpload.uniqueId}
          fileToUpload={fileToUpload}
          manageListCallbacks={manageListCallbacks}
          isLoading={isLoading}
          disabled={isUploadFinished}
        />
      ))}
      {libraryType === LibraryType.Character && filesToUpload.map((fileToUpload) => (
        <UploadFilesCharacterItem
          key={fileToUpload.uniqueId}
          fileToUpload={fileToUpload}
          manageListCallbacks={manageListCallbacks}
          isLoading={isLoading}
          disabled={isUploadFinished}
        />
      ))}
      {libraryType === LibraryType.Audio && filesToUpload.map((fileToUpload) => (
        <UploadFilesAudioItem
          key={fileToUpload.uniqueId}
          fileToUpload={fileToUpload}
          manageListCallbacks={manageListCallbacks}
          onAudioTypeChange={onAudioTypeChange}
          isLoading={isLoading}
          disabled={isUploadFinished}
        />
      ))}
    </ul>
  );
}
